<template>
    <Head>
        <title>Fiat Gateway: Шлюзы</title>
    </Head>


    <authenticated-layout :notifications="notifications" >
        <v-navigation/>
        <div class="flex flex-col bg-white">
            <form
                class="grid grid-cols-9 p-2 gap-4 items-center"
                @submit.prevent="create"
            >
                <v-toggle v-model="add.isActive" label="Активен"/>
                <div class="col-span-2 flex flex-col gap-1">
                    <v-input label="Название" v-model="add.alias" :error="errors.alias"/>
                    <v-input label="Иконка" v-model="add.icon" :error="errors.icon"/>
                </div>
                <div class="flex flex-col gap-1">
                    <v-select label="Внутренняя" v-model="add.currencyId" :error="errors.currencyId">
                        <option :value="id" v-for="(cur, id) in currencies">{{ cur.ticker }}</option>
                    </v-select>
                    <v-input
                        label="Внешняя"
                        v-model="add.currencyExternalId"
                        @change="add.settings.gatewayCurrencyID = add.currencyExternalId"
                        :error="errors.settings"
                    />
                </div>
                <v-select label="Контроллер" v-model="add.controller" :error="errors.controller">
                    <option v-for="(methods, controller) in controllers">{{controller}}</option>
                </v-select>
                <v-select label="Метод" v-model="add.methodName" :error="errors.methodName">
                    <option v-for="method in methodNames">{{method}}</option>
                </v-select>
                <v-input-json label="Настройки" class="col-span-2" v-model="add.settings" :error="errors.settings" />
                <v-button>Добавить</v-button>
            </form>
            <div class="grid grid-cols-9 border-t p-2 gap-4 font-bold" v-if="success">
                <span>Активен</span><span>Название</span><span>Валюта</span><span>Иконка</span>
                <span>Контроллер</span><span>Метод</span><span>Настройки</span>
            </div>
            <div class="grid grid-cols-9 border-t p-2 gap-4 items-center" v-for="row in result" v-if="success">
                <v-toggle v-model="row.isActive"/>
                <div>{{ row.alias }}</div>
                <div>{{ currencies[row.currencyId].ticker || '' }}</div>
                <div>{{ row.icon }}</div>
                <div>{{ row.controller }}</div>
                <div>{{ row.methodName }}</div>
                <pre class="text-xs col-span-2">{{ row.settings }}</pre>
                <Link class="text-gray-500 hover:text-blue-500" :href="route('fiat.gateway', row.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mx-auto fill-current" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </Link>
            </div>
        </div>
    </authenticated-layout>
</template>

<script>

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/FiatGateways';
import VToggle from '@/Components/Toggle';
import VInput from '@/Components/Input';
import VSelect from '@/Components/Select';
import VButton from '@/Components/Button';
import VInputJson from "@/Components/InputJson.vue";

export default {
    components: {
        VInputJson,
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VToggle,
        VInput,
        VSelect,
        VButton,
    },
    props: {
        success: Boolean,
        result: Object,
        currencies: Object,
        notifications: Array,
        controllers: Object,
        errors: Object,
    },
    data() {
        return {
            add: useForm({
                currencyId: '',
                currencyExternalId: '',
                alias: '',
                icon: '',
                isActive: false,
                methodName: '',
                controller: '',
                settings: {
                    minCommissionAmount: '',
                    commissionPercent: '',
                    gatewayCurrencyID: '',
                },
            }),
        };
    },
    mounted() {
        this.add.currencyId = Object.keys(this.currencies)[0];
    },
    methods: {
        create() {
            const {add, notifications} = this;
            notifications.push({
                type: 'success',
                title: 'Create gateway',
                message: 'Creating...',
                timeout: false,
            });
            add.post(this.route('fiat.gateways.create'));
        },
    },
    computed: {
        methodNames: {
            get() {
                const {controller} = this.add;
                if (!controller) return [];
                const {controllers} = this;
                return controllers[controller] || [];
            },
        },
    },
};
</script>
